import HeatMap from './component';

export default HeatMap;
